document.addEventListener("DOMContentLoaded", function () {
    const runOnPaths = [
        '/fr/pages/shop-our-instagram',
        '/fr',
    ];

    const path = window.location.pathname;
    const isAllowed = runOnPaths.some(p => path.startsWith(p));
    if (!isAllowed) {
        console.log(`Translator: skipping on ${path}`);
        return;
    }

    const monthMap = {
        JANUARY:   'JANVIER',
        FEBRUARY:  'FÉVRIER',
        MARCH:     'MARS',
        APRIL:     'AVRIL',
        MAY:       'MAI',
        JUNE:      'JUIN',
        JULY:      'JUILLET',
        AUGUST:    'AOÛT',
        SEPTEMBER: 'SEPTEMBRE',
        OCTOBER:   'OCTOBRE',
        NOVEMBER:  'NOVEMBRE',
        DECEMBER:  'DÉCEMBRE'
    };

    // 1) Define which elements need translating:
    const selectorsToTranslate = [
        ".fs-entry-title",         // the post caption
        ".fs-hover-product-name",  // product names
        ".fs-detail-container .fs-product-name",
        ".fs-detail-container .fs-shopify-add-cart",
        ".fs-detail-container .fs-detail-title",
        ".fs-detail-container .fs-overlink-product-name"
    ].join(", ");

    // 2) Optional manual overrides if Google Translate is off for some phrases:
    const customOverrides = {
        // 'autumnal baby': 'bébé automnal',
        // etc...
    };

    // 3) Batch‐translate an array of English strings → target language:
    async function batchTranslate(values, src = "en", tgt = "fr") {
        const joined = values.join("\n");
        const url = `https://translate.googleapis.com/translate_a/single`
            + `?client=gtx&sl=${src}&tl=${tgt}&dt=t&q=${encodeURIComponent(joined)}`;
        try {
            const res = await fetch(url);
            const data = await res.json();
            // data[0] is [ [ translatedChunk, originalChunk, … ], … ]
            return data[0].map(chunk => chunk[0]);
        } catch (e) {
            console.error("Batch translate failed:", e);
            // fallback to original
            return values;
        }
    }

    // 4) Core mutation handler:
    async function handleMutations() {
        document.querySelectorAll('.fs-detail-date').forEach(el => {
            if (el.dataset.monthReplaced) return;
            let txt = el.textContent.trim().toUpperCase();
            Object.entries(monthMap).forEach(([eng, fr]) => {
                txt = txt.replace(new RegExp(`\\b${eng}\\b`, 'g'), fr);
            });
            el.textContent = txt;
            el.dataset.monthReplaced = 'true';
        });

        // Find all matching elements:
        const els = Array.from(document.querySelectorAll(selectorsToTranslate))
            // but only those not translated yet:
            .filter(el => !el.dataset.translated);

        if (els.length === 0) return;

        // Extract unique English strings:
        const unique = [...new Set(els.map(el => el.textContent.trim()))];

        // Translate them in a single batch:
        const translated = await batchTranslate(unique, "en", "fr");

        // Build a map english→french:
        const map = {};
        unique.forEach((eng, i) => {
            let fr = translated[i];
            // apply any custom override:
            if (customOverrides[eng]) fr = customOverrides[eng];
            map[eng] = fr;
        });

        // Apply translations back to each element:
        els.forEach(el => {
            const before = el.textContent.trim();
            const after  = map[before] || before;
            el.textContent = after;
            el.dataset.translated = "true";
        });
    }

    // 5) Wire up a MutationObserver on the container that holds your posts:
    const container = document.querySelector(".shopify-section > .page-content");
    if (container) {
        const observer = new MutationObserver(handleMutations);
        observer.observe(container, { childList: true, subtree: true });
    }

    const modal = document.querySelector(".fs-prepended-detail.fs-wrapper");
    if (modal) {
        const observer = new MutationObserver(handleMutations);
        observer.observe(modal, { childList: true, subtree: true });
    }

    // 6) Run once up‑front for anything already on the page:
    handleMutations();

    // 1) Create a <style> tag
    const style = document.createElement('style');
    style.type = 'text/css';

    // 2) Put your CSS rules here:
    style.textContent = `
    .fs-has-links::after {
        content: "ACHETEZ-LE" !important;
    }
  `;

    // 3) Append it to <head>
    document.head.appendChild(style);
});
